import React from "react";
import { useEffect } from "react";

function Imagehover({ path, active, mPos }) {
  const [mousePosition, setMousePosition] = React.useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const updateMousePosition = (ev) => {
      setMousePosition({ x: ev.clientX, y: ev.pageY });
      // console.log(mousePosition.x,mousePosition.y);
    };

    window.addEventListener("mousemove", updateMousePosition);

    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
    };
  });

  return (
    <img
      // ref={ref}
      className={`z-0 ${
        path
          ? " hidden  tablet:w-1/5 tablet:max-w-xs tablet:inline absolute"
          : "hidden"
      }`}
      style={{
        left: mousePosition.x,
        top: mousePosition.y,
        transform: "translate(-20%,-75%)",
      }}
      src={path}
      alt="speaker portrait"
    ></img>
  );
}

export default Imagehover;
